<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <strong>配信テンプレート</strong>
          </CCardHeader>
          <CCardBody>
            <CForm class="member-info">
              <CRow>
                <CCol lg="6">
                  <CSelect
                    label="カテゴリー"
                    horizontal
                    :options="categoryOption"
                    :value.sync="selectedCategory"
                    placeholder="Please select"
                  />
                  <!-- <p>Selected Category: {{ selectedCategory }}</p> -->
                  <!-- <p>Category options: {{ categoryOption }}</p> -->
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <!-- <CInputFile
                    label="本文"
                    name="Upload"
                    v-model="uploadedFile"
                    horizontal
                  />
                  <p>Uploaded File: {{ JSON.stringify(uploadedFile) }}</p> -->
                  <div class="form-row">
                    <label class="col-form-label col-sm-3"> 本文 </label>
                    <div class="col-sm-9">
                      <input type="file" ref="myFile" @change="selectedFile" />
                    </div>
                  </div>
                  <div v-if="text" class="border-success m-3 p-2">
                    <div v-html="text"></div>
                  </div>
                </CCol>
              </CRow>
              <CRow v-if="uploaded">
                <CCol lg="10" class="py-2">
                  <h4 class="sub-title">プレビュー</h4>
                  <p class="template_preview" v-html="vhtml"></p>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
          <CCardFooter>
            <CButton
              color="success"
              class="ml-0 px-4"
              v-on:click="saveTemplate"
            >
              <i class="icon cil-save"></i>
              アップロード
            </CButton>
          </CCardFooter>
        </CCard>
        <CButton color="secondary" class="mt-3 px-4" v-on:click="goBack">
          <i class="icon cil-arrow-left mr-2"></i>
          戻る
        </CButton>
      </CCol>
    </CRow>
    <!-- start_completeModal -->
  </div>
</template>

<script>
// import Vue from 'vue'
// Vue.config.productionTip = false;
// Vue.config.devtools = false;
import { required, maxLength } from "vuelidate/lib/validators";
export default {
  name: "配信テンプレート作成",
  data() {
    return {
      selectedCategory: "",
      categoryOption: [],
      categoryList: [
        { category: "New Year Event" },
        { category: "Weekend Discount" },
        { category: "Golden Week Discount" },
      ],
      uploadedFile: "",
      text: "",
    };
  },
  //入力項目にvalidation
  validations: {
    application: {
      summary: {
        required,
        maxLength: maxLength(100),
      },
      description: {
        required,
        maxLength: maxLength(1000),
      },
    },
  },
  beforeMount() {
    this.getCategoryOption();
  },
  methods: {
    updateFile(file) {
      const reader = new FileReader();
      reader.onload = (e) => console.log(e.target.result);
      reader.readAsText(file);
    },
    getCategoryOption() {
      this.categoryList.forEach((element) => {
        this.categoryOption.push(element.category);
      });

      // for( let i = 0; i < this.categoryList.length; i++){
      //   this.categoryOption.push(this.categoryList[i].category)
      // }
    },
    goBack() {
      // this.$router.go(-1);
      this.$router.push({ name: "配信テンプレート" });
    },
    selectedFile() {
      // console.log("selected a file");
      // console.log(this.$refs.myFile.files[0]);

      let file = this.$refs.myFile.files[0];
      if (!file || file.type !== "text/plain") return;

      let reader = new FileReader();
      reader.readAsText(file, "UTF-8");
      reader.onload = (evt) => {
        this.text = evt.target.result;
      };
      reader.onerror = (evt) => {
        console.error(evt);
      };
    },
  },
};
</script>
